import path from "path";

import * as temp from "temp";

import { execCommandAsync } from "../../Commons/ExecUtils";
import { writeFileAsync } from "../../Commons/FsUtils";
import { buildActionBegin, ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { CreateWebpackConfigurationOptions } from "../../FormWebpackConfiguration/createFormWebpackConfiguration";
import { FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";

temp.track();

function tempMKDir(affixes?: string | temp.AffixOptions): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        temp.mkdir(affixes, (err, result) => {
            if (err) {
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                reject(err);
            } else {
                resolve(result);
            }
        });
    });
}

export async function compileForm(
    gfv: string,
    formPath: string,
    resourcesDirectory: string,
    resourcesHash: string,
    buildDebugOnly: boolean,
    parentLogger: ILogger = getLogger(),
    compileForProduction: boolean,
    buildCacheOptions?: FormBuildCacheOptions
): Promise<void> {
    const logger = parentLogger.withPrefix(`COMPILE:${gfv}`);
    const pathToWebpackConfigFactory = require.resolve("../../FormWebpackConfiguration/createFormWebpackConfiguration");

    const options: CreateWebpackConfigurationOptions = {
        gfv: gfv,
        resourcesHash: resourcesHash,
        formPath: formPath,
        resourcesDirectoryPath: resourcesDirectory,
        modes: buildDebugOnly ? ["development"] : compileForProduction ? ["production"] : ["production", "development"],
        buildCacheOptions: buildCacheOptions,
    };

    const action = buildActionBegin(logger, "Compile");

    const formBuildTempDir = await tempMKDir(`candy-forms-${gfv}-build`);
    const formBuildWebpackConfig = path.join(formBuildTempDir, "webpack.config.js");
    await writeFileAsync(
        formBuildWebpackConfig,
        `
const createConfig = require(${JSON.stringify(pathToWebpackConfigFactory)}).createConfig;
module.exports = createConfig(${JSON.stringify(options)})`,
        "utf8"
    );
    const pathToWebPackExecutable = path.join(require.resolve("webpack"), "..", "..", "..", ".bin", "webpack");
    const execCommand = `${pathToWebPackExecutable} --config ${formBuildWebpackConfig}`;
    await execCommandAsync(logger, execCommand, {
        caption: "Compiling form",
    });

    action.complete();
}
